<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>{{title}}</span>
      </div>
      <div class="common head-wrapper">
        <div class="layout row">
          <label>{{title}}：</label>
          <span class="flex-1">{{invoice_info.invoice_num}}</span>
          <span class="green" v-if="invoice_info.status === 1">已入账</span>
          <span class="orange" v-else>未入账</span>
        </div>
        <div class="layout row" v-if="invoice_info.delivery_type_id === 9">
          <label>维修单：</label>
          <span class="flex-1">{{invoice_info.repair_uid}}（{{invoice_info.repair_status}}）</span>
        </div>
        <div class="layout row">
          <label>仓库：</label>
          <span class="flex-1">{{invoice_info.village_name}}-{{invoice_info.storage_name}}</span>
        </div>
        <div class="layout row">
          <label>备注：</label>
          <span class="flex-1">{{invoice_info.remark}}</span>
        </div>
        <div class="head-img">
          <img @click="previewImage(pictures.picture_url)" v-if="invoice_info.pictures" v-for="(pictures, pictures_key) in invoice_info.pictures" :key="pictures_key" :src="pictures.picture_url">
        </div>
        <!-- 预览图片 -->
        <div class="previewimg" v-if="previewFile">
          <div @click="previewclose"></div>
          <img :src="previewimg">
        </div>
      </div>
      <div class="common head-wrapper">
        <div class="head-goods">
          <span>商品种类：<span class="blue">{{invoice_info.goods_kind}}种</span></span>
          <span>总件数：<span class="blue">{{invoice_info.goods_count}}件</span></span>
        </div>
      </div>
      <div class="common goods-wrapper">
        <div class="table-head layout">
          <label class="flex-1">品名/条码</label>
          <label>数量</label>
        </div>
        <div class="layout" v-if="goods_lists" v-for="(goods, goods_key) in goods_lists" :key="goods_key">
          <label>{{goods_key+1}}</label>
          <label v-if="goods.image_url"><img :src="goods.image_url"></label>
          <label v-else><img src="../../../assets/images/no-picture.jpg"></label>
          <label class="flex-1">
            <div class="name">{{goods.goods_name}}</div>
            <div class="name">{{goods.goods_num}}</div>
          </label>
          <label>{{goods.count}}</label>
        </div>
      </div>
      <div class="common record-wrapper" v-if="come_from_approval != 1">
        <div class="record-title">操作记录</div>
        <div class="record-row layout" v-if="operate_log" v-for="(operate, operate_key) in operate_log" :key="operate_key">
          <span>{{operate.operate_content}} {{operate.operate_time_info}}</span>
          <span class="flex-1">{{operate.operate_member_name}}</span>
        </div>
      </div>
    </div>
    <div class="backdrop-bottom" v-if="invoice_info.status == 0 && come_from_approval != 1">
      <button class="entry-btn" @click="entryBtn" v-if="invoice_info.approval && invoice_info.approval.status == 3 || !invoice_info.approval && !invoice_info.approval_set">入账</button>
      <button class="edit-btn" @click="editBtn" v-if="!invoice_info.approval || invoice_info.approval && invoice_info.approval.status == 1">编辑</button>
      <button class="del-btn" @click="delBtn" v-if="!invoice_info.approval || invoice_info.approval && [1,4].indexOf(invoice_info.approval.status) >= 0">删除</button>
      <button class="entry-btn" @click="resubmitApproval()" v-if="invoice_info.approval && invoice_info.approval.status == 1">重新提交审批</button>
      <button class="entry-btn" @click="submitApproval()" v-if="!invoice_info.approval && invoice_info.approval_set">提交审批</button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { submitApproval, resubmitApproval } from '../../../assets/js/approval.js'
export default {
  name: 'InvoiceDetail',
  metaInfo: {
    title: '物资管理'
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    console.log(this.$route.query)
    this.invoice_id = this.$route.query.invoice_id
    this.delivery_type_id = this.$route.query.delivery_type_id
    this.title = this.$route.query.title_info
    if (this.$route.query.come_from_approval) {
      this.come_from_approval = this.$route.query.come_from_approval
    }
    this.getInvoiceInfo()
  },
  data () {
    return {
      title: '',
      invoice_info: [],
      goods_lists: [],
      operate_log: [],
      previewFile: false, // 预览默认关闭
      come_from_approval: 0 // 审批页面调过来时传come_from_approval=1,不展示操作按钮
    }
  },
  methods: {
    // 审批
    submitApproval () {
      submitApproval(this, this.memberId, this.villageId, this.invoice_info.type === 1 ? 4 : 5, this.invoice_info.invoice_id)
    },
    resubmitApproval () {
      resubmitApproval(this, this.memberId, this.villageId, this.invoice_info.approval.approval_id)
    },
    getInvoiceInfo () {
      this.axios.post('/wechat/Invoice/getInvoiceInfo', {
        member_id: this.memberId,
        village_id: this.villageId,
        invoice_id: this.invoice_id
      }).then((res) => {
        console.log('getInvoiceInfo:')
        console.log(res)
        if (res.data.status === 1) {
          this.invoice_info = res.data.data
          this.goods_lists = res.data.data.goods
          this.operate_log = res.data.data.operate_log
          if (!this.title) {
            this.title = this.invoice_info.delivery_type_name
          }
        }
      }).catch(() => {
        this.loading = false
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    editBtn () {
      console.log(this.invoice_info)
      var text = ''
      if (this.invoice_info.repair_keeper_name) {
        // text = this.invoice_info.repair_keeper_name + '(' + this.invoice_info.repair_keeper_tel + ')'
        text = this.invoice_info.repair_keeper_name
      }
      var repairUid = this.invoice_info.repair_uid + ' ' + text
      console.log(this.invoice_info.repair_keeper_name)
      console.log(this.invoice_info.repair_keeper_tel)
      console.log(repairUid)
      this.$router.push({name: 'SelecteGoods', query: {invoice_id: this.invoice_id, delivery_type_id: this.delivery_type_id, repair_uid: repairUid, title_info: this.title}})
    },
    entryBtn () {
      if (this.invoice_info.type === 2 && this.invoice_info.delivery_type_id !== 14) { // 出库，检查如果负库存出库是否需要提醒
        this.axios.post('/wechat/basic_info/getAssetCurrencySetting', {
          member_id: this.memberId,
          village_id: this.villageId
        }).then((res) => {
          if (res.data.status === 1) {
            if (res.data.data['asset_currency_setting']['minus_output'] === 2) { // 当配置为需要提醒时，检查出库数量是否超过库存
              this.axios.post('/wechat/invoice/checkInventory', {
                member_id: this.memberId,
                village_id: this.villageId,
                invoice_id: this.invoice_id
              }).then((res2) => {
                if (res2.data.status === 1) {
                  if (res2.data.data.trouble_goods !== '') {
                    this.$messagebox({
                      message: res2.data.data.trouble_goods + '库存不足, 是否继续入账',
                      closeOnClickModal: false,
                      showCancelButton: true,
                      confirmButtonText: '确定'
                    }).then(action => {
                      if (action === 'confirm') { // 确认的回调
                        this.operateFunction('/wechat/Invoice/enStorage')
                      }
                    })
                  } else {
                    this.operateFunction('/wechat/Invoice/enStorage')
                  }
                } else {
                  this.$toast({
                    message: res2.data.message,
                    duration: 5000
                  })
                }
              })
            } else {
              this.operateFunction('/wechat/Invoice/enStorage')
            }
          } else {
            this.$toast({
              message: res.data.message,
              duration: 5000
            })
          }
        })
      } else {
        this.operateFunction('/wechat/Invoice/enStorage')
      }
    },
    delBtn () {
      this.$messagebox({
        message: '确定删除吗？',
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: '确定'
      }).then(action => {
        if (action === 'confirm') { // 确认的回调
          this.operateFunction('/wechat/Invoice/delInvoice')
        }
      })
    },
    operateFunction (url = '') {
      if (url === '') {
        this.$toast({
          message: '参数错误',
          duration: 5000
        })
        return false
      }
      if (this.invoice_id === 0 || this.invoice_id === undefined) {
        this.$toast({
          message: '未选择单据',
          duration: 5000
        })
        return false
      }
      this.axios.post(url, {
        member_id: this.memberId,
        village_id: this.villageId,
        invoice_id: this.invoice_id
      }).then((res) => {
        if (res.data.status === 1) {
          this.$toast({
            message: '操作成功',
            duration: 5000
          })
          this.$router.push({name: 'InvoiceList', query: {delivery_type_id: this.delivery_type_id}})
        } else {
          this.$toast({
            message: res.data.message,
            duration: 5000
          })
        }
      }).catch(() => {
        this.loading = false
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    // 预览图片
    previewImage (e) {
      this.previewFile = true
      this.previewimg = e
    },
    // 关闭预览
    previewclose () {
      this.previewFile = false
    }
  }
}
</script>
<style scoped>
.common {
  padding: 10px 15px;
}
.backdrop {
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.head-wrapper {
  font-size: 15px
}
.head-wrapper .row {
  line-height: 25px;
}
.head-wrapper .row label {
  width: 125px;
  color: #8c8c8c;
}
.head-wrapper .head-img img {
  width: 60px;
  height: 60px;
  margin: 10px 5px 10px 0 ;
}
.head-wrapper .head-goods {
  color: #8c8c8c;
}
.head-wrapper .head-goods span.blue {
  padding-right: 15px;
}
.goods-wrapper {
  font-size: 15px
}
.goods-wrapper .table-head {
  border-bottom: 1px solid #e9e9e9;
  color: #8c8c8c;
}
.goods-wrapper .table-head label {
  height: 35px;
  line-height: 35px;
}
.goods-wrapper img {
  width: 35px;
  height: 35px;
  vertical-align: middle;
  padding-right: 10px;
}
.goods-wrapper label {
  min-width: 25px;
  height: 50px;
  line-height: 50px;
}
.goods-wrapper label .name {
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.goods-wrapper label .name:first-child {
  margin-top: 8px;
}
.record-wrapper {
  font-size: 15px;
  color: #8c8c8c;
}
.record-wrapper .record-title {
  font-weight: 700;
}
.record-wrapper .record-row {
  margin-top: 8px;
}
.record-wrapper .record-row .flex-1 {
  text-align: right;
}
.backdrop-bottom {
  height: 50px;
  background-color: #ffffff;
  padding: 10px 15px;
}
.backdrop-bottom button {
  height: 30px;
  line-height: 29px;
  background-color: #ffffff;
  border-radius: 15px;
  border: 1px solid #7c7b80;
  color: #7c7b80;
  font-size: 14px;
  padding: 0 14px;
  float: right;
  margin-left: 15px;
}
.backdrop-bottom .entry-btn {
  background-color: #ff7c12;
  border: 1px solid #ff7c12;
  color: #ffffff;
}
.layout {
  display: flex;
}
.layout .flex-1 {
  flex: 1;
}
.layout .flex-2 {
  flex: 2;
}
.green {
  color: #35c53b;
}
.blue {
  color: #25ade0;
}
.orange {
  color: #fa6b2c;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/Invoice/InvoiceDetail.vue